export const FEE_DISCLAIMER =
  "Valores e prazos oficiais divulgados pelos consulados e órgãos de imigração, sujeitos a alteração sem aviso prévio. Confirmamos o valor vigente durante a sua análise de perfil. Honorários de assessoria Melo Vistos: sob consulta.";

export const COUNTRIES = {
  italia: {
    id: "italia",
    country: "Cidadania Italiana",
    headline: "Via Consular no Brasil & Via Judicial na Itália",
    image:
      "https://images.unsplash.com/photo-1753901150661-ace67d229577?auto=format&fit=crop&w=1600&q=80",
    tag: "Nossa Especialidade",
    intro:
      "Descendentes de italianos podem ter direito ao reconhecimento da cidadania italiana (iure sanguinis). A Melo Vistos conduz as duas vias possíveis: a administrativa, junto ao consulado italiano no Brasil, e a judicial, movida diretamente na Itália quando as filas consulares inviabilizam o processo. As regras de elegibilidade foram alteradas pela legislação italiana em 2025 — por isso, todo caso começa com uma análise genealógica criteriosa da sua linha de descendência.",
    visaTypes: [
      { name: "Via Consular (Brasil)", desc: "Processo administrativo junto ao consulado italiano da sua jurisdição. Não exige advogado na Itália, mas depende das filas de agendamento de cada consulado." },
      { name: "Via Judicial (Itália)", desc: "Ação judicial no tribunal italiano competente, indicada quando a fila consular é excessiva. A sentença reconhece a cidadania com a mesma validade do processo consular." },
      { name: "Análise de Elegibilidade", desc: "Revisão completa da árvore genealógica conforme as regras atuais (incluindo as restrições de gerações introduzidas em 2025) antes de qualquer investimento." },
    ],
    documents: [
      "Certidões de nascimento, casamento e óbito (inteiro teor) de toda a linha italiana, do antenato até você",
      "Certidão Negativa de Naturalização (CNN) do ancestral italiano",
      "Retificação de divergências de nomes e datas entre certidões",
      "Traduções juramentadas para o italiano",
      "Apostilamento de Haia de todos os documentos",
      "Formulários consulares e procurações (via judicial)",
    ],
    prazos: [
      { label: "Análise genealógica e elegibilidade", value: "7 a 15 dias úteis" },
      { label: "Montagem e retificação documental", value: "30 a 60 dias (varia conforme cartórios)" },
      { label: "Via consular", value: "Conforme a fila do consulado da jurisdição — pode levar anos" },
      { label: "Via judicial na Itália", value: "Estimativa de 12 a 24 meses após o protocolo (varia por tribunal)" },
    ],
    fees: [
      { label: "Taxa administrativa consular", value: "Valor alterado pela legislação italiana de 2025 — confirmamos o vigente na análise" },
      { label: "Custas judiciais na Itália", value: "Sob consulta" },
      { label: "Honorários Melo Vistos", value: "A combinar" },
    ],
  },
  usa: {
    id: "usa",
    country: "Estados Unidos",
    headline: "Visto Americano B1/B2, F1 e Renovação",
    image:
      "https://images.unsplash.com/photo-1590560876538-1d4eef066e28?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxuZXclMjB5b3JrJTIwc3RhdHVlJTIwb2YlMjBsaWJlcnR5JTIwbmlnaHR8ZW58MHx8fHwxNzkyMTc5NjI1fDA&ixlib=rb-4.1.0&q=85",
    tag: "Mais Solicitado",
    rate: "98.4%",
    intro:
      "O visto americano é o mais disputado — e o que mais pune erros de formulário. A Melo Vistos conduz seu processo do DS-160 à entrevista, com estratégia de vínculos e simulação real das perguntas do cônsul.",
    visaTypes: [
      { name: "B1/B2 — Turismo & Negócios", desc: "O visto de visitante mais solicitado, válido por até 10 anos." },
      { name: "F1 — Estudante", desc: "Para cursos acadêmicos e de idioma com I-20 aprovado." },
      { name: "Renovação", desc: "Renovação de visto vencido, em muitos casos sem nova entrevista." },
    ],
    documents: [
      "Passaporte válido (mínimo 6 meses além da viagem)",
      "Formulário DS-160 preenchido sem inconsistências",
      "Comprovante de pagamento da taxa MRV",
      "Foto 5x5 cm conforme padrão consular",
      "Comprovação de vínculos: IR, holerites, matrícula de imóvel ou empresa",
      "Extratos bancários dos últimos 3 meses",
      "Histórico de viagens anteriores (se houver)",
    ],
    prazos: [
      { label: "Análise de perfil", value: "48 horas" },
      { label: "Preenchimento do DS-160", value: "2 a 4 dias úteis" },
      { label: "Agendamento CASV + Consulado", value: "Conforme agenda (monitoramos vagas antecipadas)" },
      { label: "Retorno do passaporte após aprovação", value: "~10 dias úteis" },
    ],
    fees: [
      { label: "Taxa consular MRV (B1/B2)", value: "US$ 185 por pessoa" },
      { label: "Taxa SEVIS (F1 Estudante)", value: "US$ 350" },
      { label: "Assessoria Melo Vistos", value: "Sob consulta" },
    ],
  },
  canada: {
    id: "canada",
    country: "Canadá",
    headline: "eTA, Visto de Visitante V-1 e Estudos",
    image:
      "https://images.unsplash.com/photo-1543962226-818f4301073f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHx0b3JvbnRvJTIwc2t5bGluZSUyMG5pZ2h0fGVufDB8fHx8MTc5MjE4MDIxN3ww&ixlib=rb-4.1.0&q=85",
    tag: "eTA & Visto V-1",
    rate: "99.1%",
    intro:
      "Do eTA eletrônico ao visto de visitante com biometria, o processo canadense exige precisão nos formulários IMM e comprovação financeira consistente. Cuidamos de cada etapa, 100% digital.",
    visaTypes: [
      { name: "eTA — Autorização Eletrônica", desc: "Para quem se enquadra nos critérios de isenção de visto." },
      { name: "V-1 — Visto de Visitante", desc: "Turismo, visita a familiares e negócios curtos." },
      { name: "Estudos", desc: "Study Permit para cursos com carta de aceite (LOA)." },
    ],
    documents: [
      "Passaporte válido",
      "Formulário IMM5257 preenchido corretamente",
      "Comprovação financeira (extratos, IR, holerites)",
      "Biometria em centro VFS autorizado",
      "Carta de motivação da viagem (quando aplicável)",
      "Histórico de vínculos com o Brasil",
    ],
    prazos: [
      { label: "eTA", value: "Minutos a 72 horas" },
      { label: "Análise de perfil e formulários", value: "3 a 5 dias úteis" },
      { label: "V-1 após biometria", value: "Algumas semanas (varia por demanda)" },
    ],
    fees: [
      { label: "eTA", value: "CAD 7" },
      { label: "Visto de Visitante V-1", value: "CAD 100" },
      { label: "Biometria", value: "CAD 85" },
      { label: "Assessoria Melo Vistos", value: "Sob consulta" },
    ],
  },
  japan: {
    id: "japan",
    country: "Japão",
    headline: "Turismo, Visita a Familiares e Negócios",
    image:
      "https://images.unsplash.com/photo-1705073021025-597e7f9f5488?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHx0b2t5byUyMG5pZ2h0JTIwc2t5bGluZSUyMGphcGFufGVufDB8fHx8MTc5MjE3OTYyNXww&ixlib=rb-4.1.0&q=85",
    tag: "eVisa & Consular",
    rate: "99.7%",
    intro:
      "O consulado japonês valoriza itinerário detalhado e documentação impecável. Montamos seu roteiro dia a dia, revisamos o formulário consular e protocolamos tudo com agilidade.",
    visaTypes: [
      { name: "Turismo", desc: "Entrada única ou múltipla para lazer." },
      { name: "Visita a Familiares", desc: "Para descendentes e familiares de residentes no Japão." },
      { name: "Negócios", desc: "Reuniões, feiras e visitas técnicas de curta duração." },
    ],
    documents: [
      "Passaporte válido",
      "Formulário consular japonês revisado",
      "Foto 4,5x3,5 cm padrão japonês",
      "Itinerário de viagem completo (dia a dia)",
      "Comprovação de renda e vínculos (IR, holerites, extratos)",
      "Reservas de hospedagem e passagens",
    ],
    prazos: [
      { label: "Montagem documental + itinerário", value: "3 a 5 dias úteis" },
      { label: "Processamento consular", value: "~5 dias úteis após protocolo" },
    ],
    fees: [
      { label: "Taxa consular (entrada única)", value: "aprox. ¥3.000" },
      { label: "Assessoria Melo Vistos", value: "Sob consulta" },
    ],
  },
  mexico: {
    id: "mexico",
    country: "México",
    headline: "Visto Consular e Isenção Eletrônica (SAE)",
    image:
      "https://images.unsplash.com/photo-1512813195386-6cf811ad3542?crop=entropy&cs=srgb&fm=jpg&q=85",
    tag: "Consular & SAE",
    rate: "97.8%",
    intro:
      "Brasileiros com visto válido dos EUA, Canadá, Japão, Reino Unido ou Schengen podem entrar sem visto mexicano. Para os demais casos, conduzimos o processo consular completo via MEXITEL.",
    visaTypes: [
      { name: "Isenção (SAE)", desc: "Entrada sem visto para portadores de visto/residência elegível." },
      { name: "Visto Consular de Turismo", desc: "Para quem não se enquadra na isenção." },
      { name: "Negócios", desc: "Viagens comerciais de curta duração." },
    ],
    documents: [
      "Passaporte válido",
      "Agendamento no sistema MEXITEL",
      "Comprovação econômica: extratos, holerites ou IR",
      "Comprovante de vínculo empregatício ou empresarial",
      "Reservas de passagem e hospedagem",
    ],
    prazos: [
      { label: "Análise de elegibilidade para isenção", value: "24 horas" },
      { label: "Agendamento MEXITEL", value: "Conforme disponibilidade consular" },
      { label: "Decisão", value: "Normalmente no dia da entrevista" },
    ],
    fees: [
      { label: "Taxa consular", value: "aprox. US$ 54" },
      { label: "Assessoria Melo Vistos", value: "Sob consulta" },
    ],
  },
  china: {
    id: "china",
    country: "China",
    headline: "Visto L Turismo, M Negócios e Feiras",
    image:
      "https://images.unsplash.com/photo-1508804185872-d7badad00f7d?crop=entropy&cs=srgb&fm=jpg&q=85",
    tag: "Canton Fair & Negócios",
    rate: "98.9%",
    intro:
      "O formulário COVA e a carta-convite são os pontos críticos do visto chinês. Nossa equipe domina o processo para turismo e para delegações de negócios, incluindo a Canton Fair.",
    visaTypes: [
      { name: "L — Turismo", desc: "Passeio, com roteiro e reservas comprovados." },
      { name: "M — Negócios", desc: "Feiras, fornecedores e reuniões comerciais com carta-convite." },
      { name: "Múltiplas entradas", desc: "Para quem viaja à China com frequência." },
    ],
    documents: [
      "Passaporte válido (mínimo 6 meses)",
      "Formulário COVA preenchido sem divergências",
      "Foto padrão consular chinês",
      "Carta-convite (visto M) ou roteiro detalhado (visto L)",
      "Reservas de passagens e hospedagem",
      "Extratos bancários recentes",
    ],
    prazos: [
      { label: "Preparação COVA + documentos", value: "3 a 5 dias úteis" },
      { label: "Processamento no CVASC/Embaixada", value: "4 a 7 dias úteis" },
    ],
    fees: [
      { label: "Taxa consular + serviço CVASC", value: "aprox. US$ 140 (verificar valor vigente)" },
      { label: "Assessoria Melo Vistos", value: "Sob consulta" },
    ],
  },
  australia: {
    id: "australia",
    country: "Austrália",
    headline: "Subclass 600 Turismo, Negócios e Estudos",
    image:
      "https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?crop=entropy&cs=srgb&fm=jpg&q=85",
    tag: "ImmiAccount 100% Online",
    rate: "98.2%",
    intro:
      "O processo australiano é 100% digital via ImmiAccount — e a decisão depende da força da sua comprovação financeira e de vínculos. Montamos o dossiê completo e acompanhamos até a concessão.",
    visaTypes: [
      { name: "Subclass 600 — Turismo", desc: "Férias e visita a amigos/familiares." },
      { name: "Subclass 600 — Negócios", desc: "Reuniões e eventos corporativos." },
      { name: "Subclass 500 — Estudos", desc: "Cursos com confirmação de matrícula (CoE)." },
    ],
    documents: [
      "Passaporte válido",
      "Criação e gestão da ImmiAccount",
      "Comprovação financeira robusta (extratos, IR, investimentos)",
      "Evidências de vínculo com o Brasil (emprego, empresa, família)",
      "Histórico de viagens internacionais",
      "Seguro saúde viagem (recomendado)",
    ],
    prazos: [
      { label: "Montagem do dossiê digital", value: "5 a 7 dias úteis" },
      { label: "Decisão do Departamento de Imigração", value: "De dias a algumas semanas" },
    ],
    fees: [
      { label: "Subclass 600 (taxa oficial)", value: "a partir de ~AUD 190" },
      { label: "Assessoria Melo Vistos", value: "Sob consulta" },
    ],
  },
  others: {
    id: "others",
    country: "Reino Unido, Europa & Passaporte",
    headline: "Passaporte Brasileiro, ETIAS e Vistos Globais",
    image:
      "https://images.unsplash.com/photo-1487637419635-a2a471ff5c7b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHw0fHxwYXNzcG9ydCUyMHRyYXZlbCUyMGJvYXJkaW5nJTIwbHV4dXJ5fGVufDB8fHx8MTc5MjE3OTYyNXww&ixlib=rb-4.1.0&q=85",
    tag: "Assessoria Global",
    rate: "99.0%",
    intro:
      "Além dos grandes destinos, cuidamos da emissão e renovação do seu passaporte junto à Polícia Federal e de autorizações europeias como o ETIAS, além de vistos para Reino Unido e dezenas de outros países.",
    visaTypes: [
      { name: "Passaporte Brasileiro", desc: "Emissão e renovação com agendamento na Polícia Federal." },
      { name: "ETIAS — Europa", desc: "Autorização eletrônica para o espaço Schengen (quando exigida)." },
      { name: "Reino Unido & Outros", desc: "Standard Visitor e vistos sob demanda para qualquer destino." },
    ],
    documents: [
      "Documento de identidade e CPF",
      "Certidão de nascimento ou casamento (conforme o caso)",
      "Comprovante de pagamento da GRU",
      "Título de eleitor e quitação militar (quando aplicável)",
      "Passaporte anterior (para renovação)",
    ],
    prazos: [
      { label: "Agendamento na Polícia Federal", value: "Primeira data disponível na sua região" },
      { label: "Emissão do passaporte", value: "~6 dias úteis após o atendimento" },
      { label: "ETIAS", value: "Minutos a 96 horas" },
    ],
    fees: [
      { label: "GRU Passaporte (Polícia Federal)", value: "R$ 257,25" },
      { label: "ETIAS (quando exigido)", value: "€ 7" },
      { label: "Reino Unido — Standard Visitor", value: "a partir de ~£ 115" },
      { label: "Assessoria Melo Vistos", value: "Sob consulta" },
    ],
  },
};
